import { useSelector } from 'react-redux';
import { BodyText } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import { getNavigationItemUrl } from '../helpers/url';
import { LeftNavigationItemCount } from './LeftNavigationItemCount';
import { LeftNavigationItemGroup } from './LeftNavigationItemGroup';

import '../styles/LeftNavigationStandard.scss';

export function LeftNavigationStandard({
    persistedFiltersGroup,
    item
}) {
    const config = useConfig();
    const {
        productCount, selected, children, url, link, isProductCountHidden
    } = item;
    const dynamicAttributes = {};
    const filters = useSelector(storeState => storeState.filters.activeFilters);

    let TagName = 'div';

    if (url || link) {
        TagName = 'a';
        dynamicAttributes.href = getNavigationItemUrl(item, persistedFiltersGroup, filters, config);
    }

    return (
        <div className="left-navigation-standard">
            <TagName
                {...dynamicAttributes}
                className="left-navigation-standard__header"

            >
                <BodyText
                    className="left-navigation-standard__name"
                    color="strong"
                    level="1"
                    weight="bold"
                >
                    {getTranslatedPropertyFromContext(item, 'name', config)}
                </BodyText>
                {(!!productCount && !isProductCountHidden)
                    && (
                        <LeftNavigationItemCount
                            productCount={productCount}
                            selected={selected}
                        />
                    )}
            </TagName>
            <LeftNavigationItemGroup
                isCountHidden={isProductCountHidden}
                isSubMenu={false}
                items={children}
                persistedFiltersGroup={persistedFiltersGroup}
            />
        </div>
    );
}
